import { useContext } from 'react';
import { MaintenancePackageContext } from 'src/contexts/maintenancePackage/maintenancePackageContext';

export const useMaintenancePackage = () =>
    useContext(MaintenancePackageContext);
